module.exports = __webpack_public_path__ + "img/138.f4e227cf.jpg";